import { ReactNode } from 'react';
import { IOption } from '@shared/interfaces';

export interface INotification {
  color: string;
  data: string;
  key: string;
  message: string;
}

export interface IDataTableCell {
  value: ReactNode;
  align?: TAlignValues;
  title?: string;
}

type TAlignValues = 'left' | 'right' | 'center' | 'justify';

export interface IDataTableHeader {
  label: string;
  align?: TAlignValues;
}

export interface IUpdateOCRData {
  contactId: string;
  assetId: string;
  tableName: string;
  value: string;
  name: string;
}

export type TDataTableRow = Array<IDataTableCell>;

export interface IDataTableProps {
  rows: TDataTableRow[];
  title?: string;
  margin?: string;
  headers?: IDataTableHeader[];
  loading?: boolean;
  noResultText?: string;
}

export const SUFFIX_OPTIONS = [
  {
    value: 'Jr.',
    label: 'Jr.',
  },
  {
    value: 'Sr.',
    label: 'Sr.',
  },
  {
    value: 'II',
    label: 'II',
  },
  {
    value: 'III',
    label: 'III',
  },
  {
    value: 'IV',
    label: 'IV',
  },
];

export const relationshipTypes: IOption[] = [
  {
    value: 'Spousal',
    label: 'Spousal',
  },
  {
    value: 'Parent',
    label: 'Parent',
  },
  {
    value: 'Child',
    label: 'Child',
  },
  {
    value: 'Friend',
    label: 'Friend',
  },
  {
    value: 'FamilyOther',
    label: 'Family - Other',
  },
  {
    value: 'None',
    label: 'None',
  },
];

export enum EAlertMessage {
  Green = 'Green',
  Red = 'Red',
  Orange = 'Orange',
}

export enum EGreenAlertMessages {
  'Prequalified',
  'Title Docs Scan Accepted'
}

export interface IAlertMessages {
  individual: INotification[],
  red: INotification[],
  orange: INotification[]
}

export interface IReferralItemValue {
  firstName: string;
  lastName: string;
  contactId: string;
}

export interface IReferralValues {
  count: number;
  items: IReferralItemValue[];
}